import { render, staticRenderFns } from "./CurrentHoldingsTableV2.vue?vue&type=template&id=0d0a0030&scoped=true"
import script from "./CurrentHoldingsTableV2.vue?vue&type=script&lang=ts"
export * from "./CurrentHoldingsTableV2.vue?vue&type=script&lang=ts"
import style0 from "./CurrentHoldingsTableV2.vue?vue&type=style&index=0&id=0d0a0030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0a0030",
  null
  
)

export default component.exports